<template>
	<modal id="want-to-leave-modal" :modalOpen="modalOpen" ref="modalContainer" @close="$emit('close')">
		<div class="display-1" slot="header">Want to leave?</div>
		<div class="content body-1">If you leave this page your experiment may not be saved.</div>
		<template slot="footer">
			<md-button class="md-primary md-button-large btn-leave" @click="sendToHomeView"> Leave </md-button>
			<md-button class="md-primary md-button-large md-raised btn-stay" @click="$emit('close')"> Stay </md-button>
		</template>
	</modal>
</template>

<script>
export default {
	name: 'WantToLeaveModal',
	props: {
		modalOpen: {
			type: Boolean,
		},
	},
	data: () => ({}),
	methods: {
		sendToHomeView() {
			this.$router.push({name: 'Home'});
		},
	},
};
</script>

<style lang="scss">
#want-to-leave-modal {
	.modal-container {
		max-width: 606px;
		min-width: 0;
		min-height: 0;
		padding: 21px 24px;
		width: calc(100% - 32px);
		.header {
			padding-bottom: 8px;
		}
		.content {
			margin-bottom: 0;
		}
		.content.body-1 {
			margin-bottom: 40px;
		}
		.footer {
			@include flexRow;
			justify-content: flex-end;
			padding-bottom: 3px;
			width: 100%;
			.btn-leave {
				margin-right: 8px;
			}
		}
	}
}
</style>
